import { Sun, Moon } from 'lucide-react';
import { Button } from "@/components/ui/button";

export const ThemeToggle = ({ darkMode, setDarkMode }) => {
    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={() => setDarkMode(!darkMode)}
        >
            {darkMode ? (
                <Sun className="h-5 w-5" />
            ) : (
                <Moon className="h-5 w-5" />
            )}
        </Button>
    );
};